import { render, staticRenderFns } from "./ApprovalFiles.vue?vue&type=template&id=13583946&"
import script from "./ApprovalFiles.vue?vue&type=script&lang=js&"
export * from "./ApprovalFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13583946')) {
      api.createRecord('13583946', component.options)
    } else {
      api.reload('13583946', component.options)
    }
    module.hot.accept("./ApprovalFiles.vue?vue&type=template&id=13583946&", function () {
      api.rerender('13583946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/ApprovalFiles.vue"
export default component.exports